
function issuesVisibility (buttonID, listID, buttonClass, listClass) {
    const button = document.getElementById(buttonID);
    const list   = document.getElementById(listID);
    if (button && list) {
        button.onclick = () => {
            button.classList.toggle(buttonClass);
            list.classList.toggle(listClass);
        };
    }
}
export default function () {
    /*
        toggle visibility of issues posts when use interacts
        with the 'view all issues' button
    */
    issuesVisibility("home_issues_visibility_button", "home_issues_navigation_list", "issues_child_pages__visibility_button__inner--list_is_visible", "issues_child_pages__list--is_visible");
    /*
        handle toggling visibility of single issues sibling posts,
        when user interacts with the relevant button
    */
    issuesVisibility("issues_navigation_expand_button", "issues_navigation_list", "issues__navigation__expand_button--list_is_visible", "issues__navigation__list--is_visible");
}
